import { render, staticRenderFns } from "./EntranceTeacherExcelUpload.vue?vue&type=template&id=329970e1&"
import script from "./EntranceTeacherExcelUpload.vue?vue&type=script&lang=ts&"
export * from "./EntranceTeacherExcelUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports